<template>
  <div>
    <!--The dialog that will open the more data dialog-->
    <ReportDataDialogArticle ref="reportDataDialogArticle"></ReportDataDialogArticle>
    <ReportDataCommentDialog ref="reportDataDialogComment"></ReportDataCommentDialog>
    <!-- {{reports}} -->
    <!--Display the articles that contain active reports-->
    <v-card>
      <p class="title pa-1 text-center pt-2">Admin Reports</p>
      <v-data-table
        :headers="headers"
        :items="articles"
        :items-per-page="5"
        :expanded.sync="expanded"
        class="elevation-1"
        item-key="id"
        @click:row="expandRow"
      >
        <!--Expand of the data table - will display call nr 2.  The reports-->
        <template v-slot:expanded-item="{ headers, item }">
          <!--This td, allow the content of the expand to use the entire window, not just 1 column.-->
          <td :colspan="headers.length" style="background-color: #eee" class="pt-3">
            <!--Actions one can do-->
            <v-row style="background-color:#D8D7D7;" class="mb-2">
              <v-col md="3">
                <v-btn style="height:3em;">Warning</v-btn>
              </v-col>
              <v-col md="3">
                <v-btn style="height:3em;">Ban User</v-btn>
              </v-col>
              <v-col md="3">
                <v-btn style="height:3em;">Delete Article</v-btn>
              </v-col>
              <v-col md="3">
                <v-btn style="height:3em;">Action</v-btn>
              </v-col>
              <v-col md="3">
                <v-btn style="height:3em;">Action</v-btn>
              </v-col>
              <v-col md="3">
                <v-btn style="height:3em;">Action</v-btn>
              </v-col>
              <v-col md="3">
                <v-btn style="height:3em;">Action</v-btn>
              </v-col>
              <v-col md="3">
                <v-btn style="height:3em;">Action</v-btn>
              </v-col>
            </v-row>
            <!--Report data-->
            <v-row>
              <v-col md="12" v-for="report in item.reports" :key="report.id" class="pa-0 pa-1">
                <v-card outlined class="pa-2">
                  <div>
                    <!-- {{reports}}<br>
                    {{report.id}}<br>
                    {{report}}<br>
                    <v-btn @click="deleteMe()">Delete this report</v-btn>-->
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Reason:</span>
                      <span class="subtitle-1">{{ report.Reason }}</span>
                    </p>
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Time of report</span>
                      <span class="subtitle-1">{{ report.Created | moment('LL')}}</span>
                    </p>
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Reported by user id:</span>
                      <span class="subtitle-1">{{ report.ReportedBy }}</span>
                    </p>
                    <p class="mb-0">
                      <span class="subtitle-1 font-weight-bold pr-2">Message:</span>
                      <span class="subtitle-1">{{ report.moreDetails }}</span>
                    </p>
                  </div>
                  <!--If it is an article that being reported-->
                  <v-card-actions class="pa-0 ma-0" v-if="item.reporttype == 'article'">
                    <v-spacer></v-spacer>
                    <v-btn text @click.stop="getReportDataArticle(report)" color="error">See more</v-btn>
                  </v-card-actions>
                  <!--If i is an comment that being reported-->
                  <v-card-actions class="pa-0 ma-0" v-if="item.reporttype == 'articlecomment'">
                    <v-spacer></v-spacer>
                    <v-btn text @click.stop="getReportDataComment(report)" color="error">See more</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
// Import from store.js
import { mapActions, mapGetters } from "vuex";
// Importing the dialog, that will display the data
import ReportDataDialogArticle from "@/pages/admin/components/report/dialog/reportDataDialogArticle.vue";
import ReportDataCommentDialog from "@/pages/admin/components/report/dialog/reportDataCommentDialog.vue";
export default {
  components: {
    ReportDataDialogArticle,
    ReportDataCommentDialog,
  },
  data() {
    return {
      // Setting the dialog to false, to prevent it from opening
      reportDataDialog: false,
      // All articles that have active reports within it
      articles: [],
      // Report gotten from getAllReports, placed into an array
      reports: [],
      // The report data within specific report
      reportData: [],
      // REMNANT - remove possible
      formstatus: "",
      // part of the expand function
      expanded: [],
      // Table Headers - Note: d-none are used to hide data, but its still searchable
      headers: [
        { text: "Title", value: "Title" },
        { text: "Last reported", value: "lastReported" },
        { text: "Number of reports", value: "numReports" },
        { text: "Report type", value: "reporttype" },
        { text: "Article id", value: "id" },
      ],
    };
  },
  methods: {
    // Connect to the store.js, Getting all the reports
    ...mapActions([
      "GET_ALL_REPORT",
      "GET_ALL_REPORTS",
      "GET_ALL_REPORT_DATA",
      "DELETE_REPORT",
      "TESTA",
    ]),
    // Get all articles, and send them into the array - articles
    getAllArticles() {
      this.GET_ALL_REPORT().then((response) => {
        // console.log(response)
        // this.articles = [];
        // To get moment into the data-table, mapping over the response, using the element variable name el
        response = response.map((el) => {
          // Returning and manipulating the date using moment
          return {
            // spreading el into different parts
            ...el,
            // Next we take the key we wish to use, and place
            lastReported: this.$moment(el.lastReported).format("LL"),
          };
        });
        // Placing the response data into articles.
        this.articles = response;
      });
    },
    // Get all reports, and send them into the array - reports
    getAllReports() {
      this.formstatus = "Getting reports";
      this.GET_ALL_REPORT().then((response) => {
        this.reports = [];
        this.reports = response;
      });
    },
    // Get the report data from specific report. - Article
    getReportDataArticle(report, articles) {
      // console.log(report)
      this.GET_ALL_REPORT_DATA({
        reporttype: this.expanded[0].reporttype,
        reportid: report.id,
      })
        .then((response) => {
          this.$refs.reportDataDialogArticle.openDialog(
            response,
            this.expanded[0].reporttype
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //Get the report data from specific report. - Comment
    getReportDataComment(report, articles) {
      // console.log(report);
      this.GET_ALL_REPORT_DATA({
        reporttype: this.expanded[0].reporttype,
        reportid: report.id,
      })
        .then((response) => {
          this.$refs.reportDataDialogComment.openDialog(
            response,
            this.expanded[0].reporttype
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // Expand function
    expandRow(item) {
      // Get the reports that belongs to this article
      // console.log({item})
      this.GET_ALL_REPORTS({
        reporttype: item.reporttype,
        contentid: item.id,
      }).then((res) => {
        item.reports = res;
        // console.log({ item });
      });
      // Opens the Table expand
      this.expanded = item === this.expanded[0] ? [] : [item];
    },
    // Delete specific Report
    /*
      1. Confirm Message. If wanting to delete this report or not
      2. If Yes, then go through the reports and look for the specific report.id
      3. Use this id to specify the report to delete, and run the action.
      4. Console should tell if deleted or not.
      5. Page should refresh, and display the latest data.
        - Can be done by running a get call.
    */
    deleteThisReport(report) {
      let confirmationMessage = confirm(
        "Vil du slette denne reporten?" + "" + "report.id"
      );
      if (confirmationMessage) {
        // Need something here to find the report.id and use it regarding the call
        this.DELETE_REPORT(report.id)
          .then((response) => {
            // console.log("deleted the report");
          })
          .catch((err) => {
            console.log(err);
            alert("Kunne ikke slette");
          });
      }
    },
    deleteMe(data) {
      let confirmationMessage = confirm(
        "Vil du slette denne reporten?" + "" + "report.id"
      );
      if (confirmationMessage) {
        // Need something here to find the report.id and use it regarding the call
        this.TESTA()
          .then((response) => {
            // console.log("deleted the report");
          })
          .catch((err) => {
            console.log(err);
            alert("Kunne ikke slette");
          });
      }
    },
  },
  // When loading page, run the functions within mounted.
  mounted() {
    this.getAllArticles();
  },
};
</script>